export const initCadreSection = [
    {
        "id": "rond-cadre",
        "type": "cadre-element",
        "class": "rond-cadre cadre-element",
        "style": {
            //"color": "#ffffff00",
            //"border-color":"black",
            //"border-width" : "10px",
            //"border-style" : "solid",
            //"border-radius": "50%",
            "clip-path": "circle(50%)"
            //"clip-path": "url(#blob)"

        },
        "x": 200,
        "y": 200,
        "isLock": false,
        "src": "/images/images-default/dragndrop_carre.png",
        "width": "300px",
        "height": "300px",
        //init the crop data
        "cropCadre": {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            translate: { x: null, y: null },
            transform: null
        }

    },
    {
        "id": "roundsquare-cadre",
        "type": "cadre-element",
        "class": "roundsquare-cadre cadre-element",
        "style": {
            //"color": "#ffffff00",
            //"border-color":"black",
            //"border-width" : "10px",
            //"border-style" : "solid",
            //"border-radius": "50%",
            "clip-path": "inset(0 0 0 0 round 20%)"
            //"clip-path": "url(#blob)"

        },
        "x": 200,
        "y": 200,
        "isLock": false,
        "src": "/images/images-default/dragndrop_carre.png",
        "width": "300px",
        "height": "300px",
        //init the crop data
        "cropCadre": {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            translate: { x: null, y: null },
            transform: null
        }

    },

    {
        "id": "square-cadre",
        "type": "cadre-element",
        "class": "square-cadre cadre-element",
        "style": {
            //"color": "#ffffff00",
            //"border-color":"black",
            //"border-width" : "10px",
            //"border-style" : "solid",
            //"border-radius": "50%",
            "clip-path": "inset(0 0 0 0)"
            //"clip-path": "url(#blob)"

        },
        "x": 200,
        "y": 200,
        "isLock": false,
        "src": "/images/images-default/dragndrop_carre.png",
        "width": "300px",
        "height": "300px",
        //init the crop data
        "cropCadre": {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            translate: { x: null, y: null },
            transform: null
        }

    },

    {
        "id": "polygon-cadre",
        "type": "cadre-element",
        "class": "polygon-cadre cadre-element",
        "style": {
            //"color": "#ffffff00",
            //"border-color":"black",
            //"border-width" : "10px",
            //"border-style" : "solid",
            //"border-radius": "50%",
            "clip-path": "polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)"
            //"clip-path": "url(#blob)"

        },
        "x": 200,
        "y": 200,
        "isLock": false,
        "src": "/images/images-default/dragndrop_carre.png",
        "width": "300px",
        "height": "300px",
        //init the crop data
        "cropCadre": {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            translate: { x: null, y: null },
            transform: null
        }

    },
    {
        "id": "rectangle-vertical-cadre",
        "type": "cadre-element",
        "class": "rectangle-vertical-cadre cadre-element",
        "style": {
            //"color": "#ffffff00",
            //"border-color":"black",
            //"border-width" : "10px",
            //"border-style" : "solid",
            //"border-radius": "50%",
            "clip-path": "inset(0 0 0 0)"
            //"clip-path": "url(#blob)"

        },
        "x": 200,
        "y": 200,
        "isLock": false,
        "src": "/images/images-default/dragndrop_vertical.png",
        "width": "300px",
        "height": "600px",
        //init the crop data
        "cropCadre": {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            translate: { x: null, y: null },
            transform: null
        }

    },
    {
        "id": "rectangle-vertical-round-cadre",
        "type": "cadre-element",
        "class": "rectangle-vertical-round-cadre cadre-element",
        "style": {
            //"color": "#ffffff00",
            //"border-color":"black",
            //"border-width" : "10px",
            //"border-style" : "solid",
            //"border-radius": "50%",
            "clip-path": "inset(0 0 0 0 round 5%)"
            //"clip-path": "url(#blob)"

        },
        "x": 200,
        "y": 200,
        "isLock": false,
        "src": "/images/images-default/dragndrop_vertical.png",
        "width": "300px",
        "height": "600px",
        //init the crop data
        "cropCadre": {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            translate: { x: null, y: null },
            transform: null
        }

    },
    {
        "id": "rectangle-horizontal-cadre",
        "type": "cadre-element",
        "class": "rectangle-horizontal-cadre cadre-element",
        "style": {
            //"color": "#ffffff00",
            //"border-color":"black",
            //"border-width" : "10px",
            //"border-style" : "solid",
            //"border-radius": "50%",
            "clip-path": "inset(0 0 0 0)"
            //"clip-path": "url(#blob)"

        },
        "x": 200,
        "y": 200,
        "isLock": false,
        "src": "/images/images-default/dragndrop_horizontal.png",
        "width": "600px",
        "height": "300px",
        //init the crop data
        "cropCadre": {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            translate: { x: null, y: null },
            transform: null
        }

    },
    {
        "id": "rectangle-horizontal-round-cadre",
        "type": "cadre-element",
        "class": "rectangle-horizontal-round-cadre cadre-element",
        "style": {
            //"color": "#ffffff00",
            //"border-color":"black",
            //"border-width" : "10px",
            //"border-style" : "solid",
            //"border-radius": "50%",
            "clip-path": "inset(0 0 0 0 round 5%)"
            //"clip-path": "url(#blob)"

        },
        "x": 200,
        "y": 200,
        "isLock": false,
        "src": "/images/images-default/dragndrop_horizontal.png",
        "width": "600px",
        "height": "300px",
        //init the crop data
        "cropCadre": {
            sizePX: { width: null, height: null },
            sizePourcent: { width: null, height: null },
            translate: { x: null, y: null },
            transform: null
        }

    }


]